module.exports = __webpack_public_path__ + "img/v1-12.3f23a507.png";